import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    id: "vision-chapter-1",
    title: "Built by Dentists",
    text: "DENSA is developed by dentists who understand the problems because they experience them themselves — from everyday clinic management to the many small tasks that quietly consume a dentist's time.",
  },
  {
    num: "02",
    id: "vision-chapter-2",
    title: "Built Around Real Problems",
    text: "Finances, leads, inventory, goals, performance, follow-ups — DENSA is shaped around the real problems faced by real dental practices, not around what software companies imagine clinics need.",
  },
  {
    num: "03",
    id: "vision-chapter-3",
    title: "Built to Evolve With You",
    text: "It doesn't stop at launch. As dentists use DENSA and new challenges emerge, the platform keeps evolving with practical solutions designed around the changing needs of modern dental practices.",
  },
];

const Vision = () => (
  <section id="vision" data-testid="about-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        <div>
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">About / Our Vision</p>
            <h2 className="mt-4 text-2xl font-bold tracking-tight text-brand-ink sm:text-3xl lg:text-4xl">
              Technology that makes dentistry <span className="text-brand">smarter, simpler and more connected.</span>
            </h2>
            <p className="mt-5 text-base leading-relaxed text-slate-600">
              DENSA exists so that running a great dental practice no longer costs you your evenings, your weekends,
              or your peace of mind. One platform, one source of truth — and a dentist finally free to be a dentist.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-10 border-l-4 border-brand pl-5 text-xl font-bold leading-snug text-brand-ink sm:text-2xl">
              Built by Dentists.
              <span className="block">Built around real problems.</span>
              <span className="block text-brand">Built so you can enjoy the life you worked for.</span>
            </p>
          </Reveal>
        </div>

        <div className="space-y-2">
          {CHAPTERS.map((ch, i) => (
            <Reveal key={ch.num} delay={i * 0.08}>
              <div
                data-testid={ch.id}
                className="group grid gap-3 rounded-2xl border border-transparent p-6 transition-all duration-300 hover:border-brand/20 hover:bg-brand-mint/40 sm:grid-cols-[72px_1fr] sm:gap-6 sm:p-7"
              >
                <span className="text-3xl font-extrabold tracking-tight text-brand/30 transition-colors duration-300 group-hover:text-brand sm:text-4xl">
                  {ch.num}
                </span>
                <div>
                  <h3 className="text-lg font-semibold text-brand-ink sm:text-xl">{ch.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600 sm:text-base">{ch.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.1}>
        <div
          data-testid="about-company-block"
          className="mt-14 rounded-2xl border border-slate-200/80 bg-[#F8FAF9] p-7 sm:p-9"
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">Our Company</p>
          <p className="mt-4 max-w-3xl text-base leading-relaxed text-slate-600">
            DENSA is one of the software products and brands developed and operated by{" "}
            <span className="font-semibold text-brand-ink">AGNI HEALTHTECH SOLUTION</span>, a software development,
            SaaS and IT-enabled services business based in India. All DENSA applications, websites and services are
            owned and managed by AGNI HEALTHTECH SOLUTION.
          </p>
          <dl className="mt-6 grid gap-x-10 gap-y-4 text-sm text-slate-600 sm:grid-cols-2">
            <div>
              <dt className="font-semibold text-brand-ink">Legal Business Name</dt>
              <dd>AGNI HEALTHTECH SOLUTION</dd>
            </div>
            <div>
              <dt className="font-semibold text-brand-ink">Trade Licence No.</dt>
              <dd>HMC/W18/343498/26</dd>
            </div>
            <div>
              <dt className="font-semibold text-brand-ink">Address</dt>
              <dd>47/1 Lakshman Das Lane, Howrah 711101, India</dd>
            </div>
            <div>
              <dt className="font-semibold text-brand-ink">Contact</dt>
              <dd>+91 8240619850 · support@densa.in</dd>
            </div>
          </dl>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Vision;
